import { render } from "./ViewEditor.vue?vue&type=template&id=b376a9a6&scoped=true&ts=true"
import script from "./ViewEditor.vue?vue&type=script&lang=ts"
export * from "./ViewEditor.vue?vue&type=script&lang=ts"

import "./ViewEditor.vue?vue&type=style&index=0&id=b376a9a6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b376a9a6"]])

export default __exports__